import mqtt from "mqtt";

const EVENT_TOPIC_PATTERN = /^iv\/event\/([^/]+)\/([^/]+)$/;

export const MQTT_RECONNECT_PERIOD = 5000;
export const MQTT_MAX_RECONNECT_ATTEMPTS = 10;

export function createMqttClient() {
  const brokerUrl = process.env.REACT_APP_MQTT_BROKER_URL;
  if (!brokerUrl) {
    console.warn("[MQTT] REACT_APP_MQTT_BROKER_URL is not configured");
    return null;
  }

  const userId = sessionStorage.getItem("userId") || "anonymous";

  return mqtt.connect(brokerUrl, {
    clientId: `web_${userId}_${Date.now()}`,
    reconnectPeriod: MQTT_RECONNECT_PERIOD,
    connectTimeout: 30000,
  });
}

export function isEventTopic(topic) {
  return EVENT_TOPIC_PATTERN.test(topic);
}

export function parseEventTopic(topic) {
  const match = topic.match(EVENT_TOPIC_PATTERN);
  if (!match) {
    return null;
  }

  return {
    siteId: match[1],
    devId: match[2],
  };
}

export function parseEventPayload(message) {
  try {
    return JSON.parse(message.toString());
  } catch (e) {
    console.error("[MQTT] failed to parse message payload", e);
    return null;
  }
}

export function extractEvtCd(payload) {
  if (!payload || typeof payload !== "object") {
    return null;
  }

  return payload.evtcd ?? payload.evtCd ?? null;
}
